import React, { useState } from "react";
import { Input, Button } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import Navbar from "../common/Navbar";
import { handleSignUpSubmit } from "../../services/LoginService";
import { showErrorMessage, showSuccessMessage } from "../../utils";
import { BASE_IMG, LOGO_LOGIN_MAIN, LOGO_LOGIN_TEXT, BRAND_TAGLINE, BRAND_NAME } from "../../constants";
import "./style.css";

export default function ResetPasswordComponent() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState("password");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleShowPassword = () => {
    setShowPassword(showPassword === "password" ? "text" : "password");
  };

  const handleReset = async () => {
    if (!email || !password) {
      return;
    }

    setIsSubmitting(true);
    const name = email.split("@")[0];
    const { success, message = "" } = await handleSignUpSubmit(name, email, password);
    if (success) {
      showSuccessMessage(message || "Password updated successfully");
      navigate("/login");
    } else {
      showErrorMessage(message || "Unable to reset password right now");
    }
    setIsSubmitting(false);
  };

  return (
    <>
      <Helmet>
        <title>{BRAND_NAME} - Reset Password</title>
        <link rel="canonical" href="/reset" />
      </Helmet>
      <div>
        <Navbar showSettings={false} />
        <div className="login">
          <div className="left-container">
            <img src={`${BASE_IMG}/login_left.svg`} height="95%" width="95%" />
          </div>
          <div className="right-container">
            <div className="right-subContainer">
              <div className="app-title-logo">
                <div className="app-logo">
                  <img src={LOGO_LOGIN_MAIN} height="100%" width="100%" />
                </div>
                {LOGO_LOGIN_TEXT ? (
                  <div className="app-title">
                    <img src={LOGO_LOGIN_TEXT} />
                  </div>
                ) : null}
              </div>
              <div className="app-motto-text">{BRAND_TAGLINE}</div>

              <div className="forgot-password-container reset-password-container auth-form-container">
                <div className="login-box-text">Reset password</div>
                <p className="forgot-password-subtext">
                  Set a new password for your account.
                </p>
                <Input
                  className="login-box-input-container2"
                  id="reset-email"
                  type="email"
                  value={email}
                  placeholder="Email"
                  onChange={(e) => setEmail(e.target.value)}
                />
                <Input
                  className="login-box-input-container2"
                  id="reset-password"
                  type={showPassword}
                  value={password}
                  placeholder="New Password"
                  onChange={(e) => setPassword(e.target.value)}
                  suffix={
                    showPassword === "password" ? (
                      <img
                        src={`${BASE_IMG}/eye.svg`}
                        alt="show-password"
                        className="password-icon"
                        onClick={handleShowPassword}
                      />
                    ) : (
                      <img
                        src={`${BASE_IMG}/cross_eye.svg`}
                        alt="hide-password"
                        className="password-icon"
                        onClick={handleShowPassword}
                      />
                    )
                  }
                />
                <Button
                  disabled={!email || !password || isSubmitting}
                  className={`login-box-button-container-button ${!email || !password || isSubmitting ? "disabled-button" : ""}`}
                  onClick={handleReset}
                >
                  <div className="login-box-button-container-button-text">Continue</div>
                </Button>
                <p className="forgot-password-link">
                  <Link to="/login">Back to login</Link>
                </p>
                <p className="login-bottom-text-container-bottom reset-password-footer auth-page-footer">
                  &copy; Copyright 2026 RazeHQ. All rights reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
